import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from '../../app-config';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(private httpClient: HttpClient, private apiUrl: AppConfig) {}

  settingsPageAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.teacherApiURL.settingsPageAPI, {
      params: filterData,
    });
  };

  sendSettingsPageAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.sendSettingsPageAPI,
      data
    );
  };
  activateAccountAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.activateAccountAPI,
      data
    );
  };
  deleteAccountAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.deleteAccountAPI,
      data
    );
  };

  passwordValidationAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.passwordValidationAPI,
      data
    );
  };
  updateEmailAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.updateEmailAPI,
      data
    );
  };
  profileUpdateAPI = (data: any): Observable<any> => {
    return this.httpClient.post<any>(
      this.apiUrl.teacherApiURL.profileUpdateAPI,
      data
    );
  };
}
